import { render, staticRenderFns } from "./attackone.vue?vue&type=template&id=85b1bd6c&scoped=true"
import script from "./attackone.vue?vue&type=script&lang=js"
export * from "./attackone.vue?vue&type=script&lang=js"
import style0 from "./attackone.vue?vue&type=style&index=0&id=85b1bd6c&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b1bd6c",
  null
  
)

export default component.exports